import Explorer from '../src/KeenExplorer';

export const KeenExplorer = Explorer;
